<template>
    <div>
        <v-select
                v-model="sex"
                :items="items"
                label="Select Sex"
        ></v-select>
        <v-btn color="primary" :disabled="sex === null"  @click="handleSubmitSex">Submit</v-btn>
    </div>
</template>
<script>
    export default {
        name: 'AskSex',
        methods: {
            handleSubmitSex() {
                this.$emit('sexDefined', this.age);
            }
        },
        data: () => ({
            items: [{text: 'Male', value: 'male'}, {text: 'Female', value: 'female'}],
            sex: null,
        }),
    }
</script>